import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/setup#config-object
const firebaseConfig = {
  apiKey: "AIzaSyAaoS-kIQMly9ZByGnAHyplCAO9de24q7w",
  authDomain: "cs-poc-z6ejtkxm3lm8lvs11adig5c.firebaseapp.com",
  projectId: "cs-poc-z6ejtkxm3lm8lvs11adig5c",
  storageBucket: "cs-poc-z6ejtkxm3lm8lvs11adig5c.firebasestorage.app",
  messagingSenderId: "512304949190",
  appId: "1:512304949190:web:b98daea6e6bbd7019cb4c7",
  measurementId: "G-SBPYTL2WZG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app, 'accrue-demo');
export const storage = getStorage(app);